import { createContext, useContext, useState, useEffect } from "react";
import { API } from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get("auth/handshake").then(res => { 
      if (res.success) setUser(res.data);
      else setUser(null);
    }).catch(() => setUser(null)).finally(() => setLoading(false));
  }, []);

  return (<AuthContext.Provider value={{ user, setUser, loading }}>{children}</AuthContext.Provider>);
}

export function useAuth() {
  return useContext(AuthContext);
}